export function isJsonRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
export function expectJsonRecord(value, context) {
    if (!isJsonRecord(value)) {
        throw new Error(`Invalid payload at ${context}: expected object`);
    }
    return value;
}
export function maybeJsonRecord(value) {
    return isJsonRecord(value) ? value : null;
}
export function parseJsonRecord(raw, context) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch (err) {
        throw new Error(err instanceof Error ? `Invalid JSON at ${context}: ${err.message}` : `Invalid JSON at ${context}`);
    }
    return expectJsonRecord(parsed, context);
}
export function requireString(root, key, context) {
    const value = root[key];
    if (typeof value !== 'string') {
        throw new Error(`Invalid payload at ${context}.${key}: expected string`);
    }
    return value;
}
export async function readResponseJsonRecord(response, context) {
    let parsed;
    try {
        parsed = await response.json();
    }
    catch (err) {
        throw new Error(err instanceof Error ? `Invalid response JSON at ${context}: ${err.message}` : `Invalid response JSON at ${context}`);
    }
    return expectJsonRecord(parsed, context);
}
//# sourceMappingURL=runtime-validation.js.map